export default __webpack_public_path__ + "static/media/portfolio-cregar-4.15eaab08.jpg";